import http from '@/http';
import { API } from '@/constants/api';
import { camelize, snakelize } from '@/utils/parse';

/**
 * @param   {array}     fileInfo  include keys: filename, content_type
 */
export async function getSignature(fileInfo) {
  try {
    const payload = snakelize(fileInfo);
    const { status, data } = await http.post(
      API.DIRECT_UPLOAD.GET_SIGNATURE,
      payload,
    );

    if (status === 200) {
      return {
        success: true,
        data: camelize(data[0]),
      };
    }
    return {
      success: false,
    };
  } catch (error) {
    console.error(error);

    return {
      success: false,
    };
  }
}
